export default __webpack_public_path__ + "static/media/paper_unfold.6d986b06.mp3";